import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import * as Sentry from '@sentry/browser';
import emailRegex from 'utils/emailRegex';
import actions from 'api/actions';
import scrollToElement from 'scroll-to-element';
import _ from 'lodash';
import Modal from 'components/shared/modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FaqContainer, FaqItem } from 'components/shared/faq-item';
import TeacherCard from './teacher-card';
import SectionHeader from 'components/shared/landing/section-header';
import HorizontalCarousel from 'components/shared/horizontal-carousel';
import educatorInSchool from 'assets/img/certified-educators-in-school.png';
import educatorOutSchool from 'assets/img/certified-educators-out-of-school.png';
import ValeriaImage from 'assets/img/valeria-testimonial-image.jpg';
import ChristinaImage from 'assets/img/christina-luaces-ulc.jpg';
import SilviaImage from 'components/containers/unauthenticated/services/img/Silvia Mendoza Pic.jpg';
import { HeaderText, Underline } from 'components/shared/landing/main-header';
import styles from './styles.module.scss';
import { IconList, IconListItem } from 'components/shared/landing/icon-list';

const teachers = [
  {
    name: 'Silvia Mendoza, Masters Curriculum, Middle & HS Teacher',
    image: SilviaImage,
    quote:
      'Becoming certified has changed not only the dynamic with my students and improved their problem solving attitudes and abilities, but also my own home life! In order to help students develop their SEL Power Skills, I embraced the skills myself and continue to develop them every day.',
  },
  {
    name: 'Valeria Rodriguez, Masters Instructional Technology, Elementary',
    image: ValeriaImage,
    quote:
      "Almost immediately after getting certified, I started to see education and development unlike I had ever before. I've applied the methods and technology tools to get results in my classroom and now am excited to help students develop as problem solvers through my Unyted Learning Center, too.",
  },
  {
    name: 'Christina Luaces, Masters Educational Leadership & Instructional Tech.',
    image: ChristinaImage,
    quote:
      'I became certified with Unyted because, as an educator, I could help students develop positive behaviors and academic growth at the same time. I want to faciliate development in a motivated and engaging environment ensured by the Unyted technology.',
  },
];

class UnytedCertifiedInstructors extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentCarouselPage: 0,
      newApplication: {
        name: '',
        email: '',
        location: '',
        role: '',
      },
      errors: {},
      applying: false,
      applySuccess: false,
      applyError: null,
    };

    this.onCarouselPrev = this.onCarouselPrev.bind(this);
    this.onCarouselNext = this.onCarouselNext.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.toggleApplying = this.toggleApplying.bind(this);
  }

  onCarouselPrev() {
    this.setState(prevState => ({
      currentCarouselPage:
        prevState.currentCarouselPage === 0
          ? 0
          : prevState.currentCarouselPage - 1,
    }));
  }

  onCarouselNext() {
    this.setState(prevState => ({
      currentCarouselPage:
        prevState.currentCarouselPage < teachers.length - 1
          ? prevState.currentCarouselPage + 1
          : prevState.currentCarouselPage,
    }));
  }

  onChange(e) {
    const { newApplication } = this.state;

    this.setState({
      newApplication: _.merge(newApplication, {
        [e.target.name]: e.target.value,
      }),
    });
  }

  onSubmit(e) {
    e.preventDefault();

    const { newApplication } = this.state;

    const blankFields = Object.keys(newApplication).filter(
      field => !newApplication[field],
    );

    const emailError = !emailRegex.test(newApplication.email);

    if (blankFields.length > 0 || emailError) {
      this.setState({
        errors: _.zipObject(
          blankFields,
          _(_.range(blankFields.length))
            .map(number => true)
            .value(),
        ),
      });
    } else {
      actions
        .post('leads', newApplication)
        .then(r => this.setState({ applySuccess: true }))
        .catch(e => {
          Sentry.captureException(e);
          this.setState({ applyError: true });
        });
    }
  }

  toggleApplying() {
    this.setState(prevState => ({ applying: !prevState.applying }));
  }

  render() {
    const {
      currentCarouselPage,
      name,
      email,
      location,
      role,
      errors,
      applying,
      applySuccess,
      applyError,
    } = this.state;

    return (
      <div className={styles.certifiedInstructors}>
        <section className={styles.header}>
          <div className="container">
            <div className="row">
              <div className="col-12 d-flex flex-column align-items-center">
                <HeaderText>
                  <Underline>Empower yourself and K-12 kids</Underline>
                </HeaderText>
                <p>
                  Becoming a Unyted Certified Educator means more freedom for
                  you and the learners you impact through our patent-pending
                  technology & group learning methods.
                </p>
                <button
                  type="button"
                  onClick={this.toggleApplying}
                  className="apple"
                >
                  Apply Now
                </button>
                <button
                  type="button"
                  onClick={() => scrollToElement('#faq')}
                  className="link p-0 m-0 blue"
                >
                  Questions? View our FAQ
                </button>
              </div>
            </div>
          </div>
        </section>
        <section className={styles.lightBlue}>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <SectionHeader
                  tagline="designed for you"
                  valueprop="Benefits of Certification"
                />
              </div>
            </div>
            <div className={styles.step1}>
              <div
                className={`col-12 col-lg-6 order-2 order-lg-1 ${styles.textContainer}`}
              >
                <h2>Used Out Of School</h2>
                <p>
                  Your certification reaches beyond the traditional classroom
                  and, through{' '}
                  <Link to="/unyted-learning-centers">
                    Unyted Learning Centers
                  </Link>
                  , allows you to use your talents in ways that benefit yourself
                  and learners.
                </p>
                <IconList>
                  <IconListItem icon="check" iconClassName="text-apple">
                    Eligible to open own{' '}
                    <Link to="/unyted-learning-centers">
                      Learning Center without the large upfront financial
                      investment
                    </Link>{' '}
                  </IconListItem>
                  <IconListItem icon="check" iconClassName="text-apple">
                    Transform freelance tutoring with a full online platform of
                    features that include: training, Video conferencing,
                    scheduling, payment, session reporting + data, Library of
                    Activities, learner management.
                  </IconListItem>
                  <IconListItem icon="check" iconClassName="text-apple">
                    Be compensated as a talented partner; not an employee
                  </IconListItem>
                  <IconListItem icon="check" iconClassName="text-apple">
                    Connect with learners anywhere in the world
                  </IconListItem>
                  <IconListItem icon="check" iconClassName="text-apple">
                    Experience more autonomy to educate and coach your way
                  </IconListItem>
                </IconList>
              </div>
              <div className="col-12 col-lg-6 order-1 order-lg-2">
                <img
                  alt="Tools designed for educators to do more"
                  src={educatorOutSchool}
                />
              </div>
            </div>
            <div className={styles.step2}>
              <div className="col-12 col-lg-6">
                <img
                  alt="Visibility into group interactions"
                  src={educatorInSchool}
                />
              </div>
              <div className={`col-12 col-lg-6 ${styles.textContainer}`}>
                <h2>Used In School</h2>
                <p>
                  Educators within schools are often certified as part of a
                  school's plan to go beyond traditional education and elevate
                  learners to higher order thinking, creativity, and
                  problem-solving.
                </p>
                <IconList>
                  <IconListItem icon="check" iconClassName="text-apple">
                    Use of full online platform of features that include:
                    training, learner manangement, small group tools, Library of
                    Activities, real time data and records.{' '}
                  </IconListItem>
                  <IconListItem icon="check" iconClassName="text-apple">
                    Adapt easier with tools built for differentiated
                    instruction.
                  </IconListItem>
                  <IconListItem icon="check" iconClassName="text-apple">
                    Elevate classroom discussion through patent-pending{' '}
                    <Link to="/unyted-learning-centers">
                      collaborative learning method
                    </Link>{' '}
                  </IconListItem>
                  <IconListItem icon="check" iconClassName="text-apple">
                    Engage learners with online project-based learning tools
                  </IconListItem>
                  <IconListItem icon="check" iconClassName="text-apple">
                    Connect learners to the real world through transferable
                    skills gained during academic learning
                  </IconListItem>
                </IconList>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <SectionHeader
                  tagline="become certified"
                  valueprop="How To Start"
                />
              </div>
            </div>
            <div
              className={`${styles.getStarted} row mt-2 justify-content-center`}
            >
              <div className="col-12">
                <div className="row">
                  <div className="col-12 col-md-4 d-flex flex-column align-items-center text-center">
                    <FontAwesomeIcon
                      icon={['far', 'comment-alt']}
                      className="text-green mb-3"
                      size="6x"
                    />
                    <span className="fa-layers fa-fw fa-2x">
                      <FontAwesomeIcon
                        icon="circle"
                        className="text-purple"
                        size="lg"
                      />
                      <strong>1</strong>
                    </span>
                    <strong className="font-130 mt-2">Contact</strong>
                    <p>
                      Contact us, receive an immediate response, and a
                      convenient way to start the process.
                    </p>
                  </div>
                  <div className="col-12 col-md-4 d-flex flex-column align-items-center text-center">
                    <FontAwesomeIcon
                      icon={['fas', 'tasks']}
                      className="text-green mb-3"
                      size="6x"
                    />
                    <span className="fa-layers fa-fw fa-2x">
                      <FontAwesomeIcon
                        icon="circle"
                        className="text-purple"
                        size="lg"
                      />
                      <strong>2</strong>
                    </span>
                    <strong className="font-130 mt-2">Prepare</strong>
                    <p>
                      We provide a list of 7 key actions you'll use to best
                      develop "Unyted kids."
                    </p>
                  </div>
                  <div className="col-12 col-md-4 d-flex flex-column align-items-center text-center">
                    <FontAwesomeIcon
                      icon={['far', 'file-certificate']}
                      className="text-green mb-3"
                      size="6x"
                    />
                    <span className="fa-layers fa-fw fa-2x">
                      <FontAwesomeIcon
                        icon="circle"
                        className="text-purple"
                        size="lg"
                      />
                      <strong>3</strong>
                    </span>
                    <strong className="font-130 mt-2">Demonstrate</strong>
                    <p>
                      You then demonstrate - in-person or online - your ability
                      to execute the 7 key actions.
                    </p>
                  </div>
                  <div className="py-3 d-flex w-100 justify-content-center">
                    <button
                      type="button"
                      onClick={this.toggleApplying}
                      className="apple"
                    >
                      Apply Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className={styles.lightBlue}>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <SectionHeader
                  tagline="testimonials"
                  valueprop="Hear It From the Educators"
                />
              </div>
            </div>
            <div className="row mt-2 justify-content-center">
              <div className="col-12">
                <HorizontalCarousel
                  current={currentCarouselPage}
                  onClickPrev={this.onCarouselPrev}
                  onClickNext={this.onCarouselNext}
                  numDisplayItems={1}
                  leftIconClassName={styles.carouselIcon}
                  rightIconClassName={styles.carouselIcon}
                >
                  {teachers.map(teacher => (
                    <TeacherCard key={teacher.name} teacher={teacher} />
                  ))}
                </HorizontalCarousel>
              </div>
            </div>
          </div>
        </section>
        <section id="faq" className={styles.white}>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <SectionHeader tagline="any questions?" valueprop="FAQ" />
              </div>
            </div>
            <div className="row mt-2 justify-content-center">
              <div className="col-12">
                <FaqContainer>
                  <FaqItem question="How do I get started?">
                    <p>
                      Click{' '}
                      <button
                        onClick={this.toggleApplying}
                        className="link blue p-0"
                      >
                        here
                      </button>{' '}
                      to fill out the form and get started. If you have
                      questions or concerns, simply click the messaging button
                      at the bottom right to quickly connect with a Unyted team
                      member.
                    </p>
                  </FaqItem>
                  <FaqItem question="How long does it take to hear back once I've applied and how long does the overall process take?">
                    <p>
                      You will hear back within 2 business days. How long the
                      process takes depends on you. There are different
                      certification plans for in-school and out of school
                      scenarios. Once you're ready, it can even happen within a
                      day!
                    </p>
                  </FaqItem>
                  <FaqItem question="What is the financial cost to be certified?">
                    <p>
                      To individual, eligible educators, it's completely free.
                    </p>
                  </FaqItem>
                  <FaqItem question="What is the cost of starting a Unyted Learning Center?">
                    <p>
                      Currently, we are waiving all fees to start your own
                      learning center. While freelance tutors may have to pay a
                      monthly fee or upfront cost on other platforms, our focus
                      is on certification of your ability to develop problem
                      solvers.{' '}
                    </p>
                  </FaqItem>
                  <FaqItem question="Is certification for all educators?">
                    <p>
                      Plainly, developing problem solving "Unyted kids" is not
                      for every educator. We seek to partner with those who aim
                      to go beyond traditional education and elevate the process
                      to higher order thinking and genuine skill development.{' '}
                    </p>
                  </FaqItem>
                </FaqContainer>
              </div>
            </div>
          </div>
        </section>
        {applying && (
          <Modal
            bodyClass="w-100"
            heading="Become a Unyted Certified Instructor"
            onClose={this.toggleApplying}
            noFooter
          >
            {applySuccess ? (
              <div>
                <strong className="font-lg">Success!</strong>
                <p>
                  Thank you for applying. We will be reaching out to you within
                  48 hours.
                </p>
              </div>
            ) : (
              <form
                className="d-flex flex-column align-items-center"
                onSubmit={this.onSubmit}
              >
                <div className="form-group w-100">
                  <label className="font-heavy" htmlFor="name">
                    Name*
                  </label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    value={name}
                    placeholder="Name"
                    onChange={this.onChange}
                  />
                  {errors.name && (
                    <p className="text-red font-heavy pl-1 mb-0">
                      Field cannot be blank
                    </p>
                  )}
                </div>
                <div className="form-group w-100">
                  <label className="font-heavy" htmlFor="name">
                    Email*
                  </label>
                  <input
                    type="text"
                    name="email"
                    className="form-control"
                    value={email}
                    placeholder="Email"
                    onChange={this.onChange}
                  />
                  {errors.email && (
                    <p className="text-red font-heavy pl-1 mb-0">
                      Please check the format of your email and try again
                    </p>
                  )}
                </div>
                <div className="form-group w-100">
                  <label className="font-heavy" htmlFor="location">
                    Location*
                  </label>
                  <input
                    type="text"
                    name="location"
                    className="form-control"
                    value={location}
                    placeholder="Location (City, State)"
                    onChange={this.onChange}
                  />
                  {errors.location && (
                    <p className="text-red font-heavy pl-1 mb-0">
                      Field cannot be blank
                    </p>
                  )}
                </div>
                <div className="form-group w-100">
                  <label className="font-heavy" htmlFor="role">
                    Current Role*
                  </label>
                  <input
                    type="text"
                    name="role"
                    className="form-control"
                    value={role}
                    placeholder="Current Role (Teacher, Administrator, etc)"
                    onChange={this.onChange}
                  />
                  {errors.role && (
                    <p className="text-red font-heavy pl-1 mb-0">
                      Field cannot be blank
                    </p>
                  )}
                </div>
                {applyError && (
                  <p className="text-red font-heavy">
                    Sorry, something went wrong. Please refresh and try again.
                  </p>
                )}
                <button
                  type="submit"
                  disabled={applyError}
                  className={`blue w-75 ${applyError ? 'disabled' : ''}`}
                >
                  Submit
                </button>
              </form>
            )}
          </Modal>
        )}
      </div>
    );
  }
}
export default UnytedCertifiedInstructors;
